import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  IconButton,
  Button,
  Grid,
  Tooltip,
  Menu,
  MenuItem,
  CircularProgress,
} from '@mui/material';
import {
  FavoriteBorder,
  Favorite,
  PeopleAlt,
  Share,
  ThumbUpAltOutlined, 
  ThumbUpAlt,
  Call,
  LocationOn,
  ChevronLeft,
  ChevronRight,
  MoreVert,
} from '@mui/icons-material';
import axios from 'axios';
import buildingImage from './../../../../Images/house.jpeg';
import CustomSearchBar from './../../Lease Module/CustomSearch';
import BottomNavbar from './../../Post Module/FormsBottomNavbar';
import { AuthContext } from './../../../AuthContext/AuthContext';
import { BASE_URL } from './../../../Api/ApiUrls';
import { useLocation } from 'react-router-dom';
import CopyFailureAlert from '../../Alertpage/CopyAlert/CopyFailureAlert';
import CopySuccessAlert from '../../Alertpage/CopyAlert/CopySuccessAlert';
import ShareCopySuccessAlert from '../../Alertpage/ShareAlert/ShareCopySuccessAlert';
import ShareCopyFailureAlert from '../../Alertpage/ShareAlert/ShareCopyFailureAlert';
import DeleteFailureAlert from '../../Alertpage/DeleteAlert/DeleteFailureAlert';
import DeleteSuccessAlert from '../../Alertpage/DeleteAlert/DeleteSuccessAlert';
import DeleteConfirmAlert from '../../Alertpage/DeleteAlert/DeleteConfirmAlert';
import BoostFailureAlert from '../../Alertpage/CopyAlert/BoostFailureAlert';
import BoostSuccessAlert from '../../Alertpage/CopyAlert/BoostAlert';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

const API_BASE_URL = 'https://landnest.net:7000/api';

const UserBestdeals = () => { 
  const navigate = useNavigate();
  const locationn = useLocation();
  const { userId, logout } = useContext(AuthContext);
  const [searchQuery, setSearchQuery] = useState(''); 
  const [anchorEl, setAnchorEl] = useState(null);
  const [daysLeft, setDaysLeft] = useState(null);
  const [error, setError] = useState(null);
  const [menuPropertyId, setMenuPropertyId] = useState(null);
  const [saved, setSaved] = useState(() => {
    const stored = localStorage.getItem('savedBuy');
    return stored ? JSON.parse(stored) : [];
  });
  const [likedCards, setLikedCards] = useState({});
  const [properties, setProperties] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentImageIndex, setCurrentImageIndex] = useState({});
const [showSuccess, setShowSuccess] = useState(false);
const [showFailure, setShowFailure] = useState(false);
const [alertMessage, setAlertMessage] = useState("");
const [showShareSuccess, setShowShareSuccess] = useState(false);
const [showShareFailure, setShowShareFailure] = useState(false);
const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
const [showDeleteFailure, setShowDeleteFailure] = useState(false);
const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
const [menuPropertyIdToDelete, setMenuPropertyIdToDelete] = useState(null);
// Add these new state variables for boost functionality
const [showBoostSuccess, setShowBoostSuccess] = useState(false);
const [showBoostFailure, setShowBoostFailure] = useState(false);
const [boostLoading, setBoostLoading] = useState(false);

const handleCallClick = async (e, property) => {
  e.stopPropagation();

  try {
    if (property.mobile_no) {
      await navigator.clipboard.writeText(property.mobile_no);

      setAlertMessage(`Copied: ${property.mobile_no}`);
      setShowSuccess(true);
      setShowFailure(false);
    } else {
      setAlertMessage("Mobile number not available");
      setShowFailure(true);
      setShowSuccess(false);
    }
  } catch (error) {
    setAlertMessage("Failed to copy mobile number");
    setShowFailure(true);
    setShowSuccess(false);
  }
};
const handleShare = async (event, property) => {
  event.stopPropagation();

  const propertyUrl = `${window.location.origin}/hot-property-description/${property.id}`;

  try {
    await navigator.clipboard.writeText(propertyUrl);

    setAlertMessage("Property link copied successfully!");
    setShowShareSuccess(true);
    setShowShareFailure(false);
  } catch (error) {
    setAlertMessage("Failed to copy property link");
    setShowShareFailure(true);
    setShowShareSuccess(false);
  }
};
  const handleMenuOpen = (event, propertyId) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setMenuPropertyId(propertyId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuPropertyId(null);
  };

  const handleEdit = () => {
    navigate(`/user-edit-bestdeal/${menuPropertyId}`);
  };

const handleDelete = async () => {
  if (!menuPropertyIdToDelete) return;

  try {
    const response = await fetch(`${BASE_URL}/property/${menuPropertyIdToDelete}/`, {
      method: 'DELETE',
    });

    if (response.ok) {
      // Remove from state immediately
      setProperties(prev => prev.filter(p => p.id !== menuPropertyIdToDelete));
      setAlertMessage(`Property ID ${menuPropertyIdToDelete} deleted successfully.`);
      setShowDeleteSuccess(true);
      fetchData(); // Optional: refresh data
    } else {
      const errorData = await response.json();
      setAlertMessage(
        `Failed to delete property ID ${menuPropertyIdToDelete}. Reason: ${errorData.detail || "Unknown error"}`
      );
      setShowDeleteFailure(true);
    }
  } catch (error) {
    console.error("Error deleting property:", error);
    setAlertMessage("An error occurred while trying to delete the property.");
    setShowDeleteFailure(true);
  } finally {
    setMenuPropertyIdToDelete(null);
    handleMenuClose();
  }
};

const getPropertyImages = async (propertyId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/properties/${propertyId}/images`);
    const data = await response.json();

    if (!response.ok) throw new Error(data.error || 'Failed to fetch images');
    return data;
  } catch (error) {
    console.error('API Error fetching images:', error);
    return { success: false, images: [] };
  }
};

    const fetchData = async () => {
      try {
        setLoading(true);
        const categoriesResponse = await axios.get(`${BASE_URL}/property-category/`);
        setCategories(categoriesResponse.data);

           const propertiesResponse = await axios.get(`${API_BASE_URL}/api/properties/user/${userId}?type=best-deal`);
           console.log('API Response:', propertiesResponse.data); // 👈 add this
       
        

              // Fetch user subscriptions
        const plansResponse = await axios.get(`${BASE_URL}/Get-all-plan/${userId}/`);
        const subscriptions = plansResponse.data || [];

        const cartResponse = await axios.get(`${BASE_URL}/user-cart/`);
        const cartItems = cartResponse.data;
        
        const enquiriesResponse = await axios.get(`${BASE_URL}/Enquiry/`);
        const enquiries = enquiriesResponse.data;

        const filtered = propertiesResponse.data.data
          .filter(item => 
          
            item.created_at
          )
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

        const parsed = await Promise.all(filtered.map(async (item) => {
  const wishlistUsers = cartItems
  .filter(
    cartItem =>
      cartItem.property_id === item.property_id &&
      cartItem.user_id !== userId
  )
  .map(cartItem => cartItem.user_id);

const wishlistCount = [...new Set(wishlistUsers)].length;
          const postedBy = item.posted_by?.replace(/"/g, '') || '';
const requiredUserType = mapPostedByToUserType(postedBy);

// Find matching active subscription
const matchedSub = subscriptions.find(
  sub =>
    sub.status === true &&
    sub.user_type === requiredUserType
);

// Calculate days left for THIS property
const daysLeftForProperty = matchedSub?.expired_date
  ? calculateDaysLeft(matchedSub.expired_date)
  : null;

          
          const matchingBuyersCount = enquiries.filter(enquiry => {
            const propertyCategory = categoriesResponse.data.find(
              cat => cat.category_id == item.category_id
            )?.category;
            
            const typeMatch = enquiry.property_type && propertyCategory && 
              enquiry.property_type.toLowerCase() === propertyCategory.toLowerCase();
            
            const budgetMatch = enquiry.min_budget && enquiry.max_budget && item.price &&
              (item.price >= enquiry.min_budget && item.price <= enquiry.max_budget);
            
            const locationMatch = () => {
              if (!enquiry.lat || !enquiry.long || !item.lat || !item.long) return false;
              
              const propLat = parseFloat(item.lat);
              const propLong = parseFloat(item.long);
              const enqLat = parseFloat(enquiry.lat);
              const enqLong = parseFloat(enquiry.long);
              
              const R = 6371;
              const dLat = (enqLat - propLat) * Math.PI / 180;
              const dLon = (enqLong - propLong) * Math.PI / 180;
              const a = 
                Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.cos(propLat * Math.PI / 180) * Math.cos(enqLat * Math.PI / 180) * 
                Math.sin(dLon/2) * Math.sin(dLon/2);
              const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
              const distance = R * c;
              
              return distance <= 10;
            };
            
            return typeMatch && budgetMatch && locationMatch();
          }).length;

          const parseCoord = (coord) => {
            if (!coord) return null;
            const cleaned = coord.replace(/"/g, '').replace(':', '.');
            return parseFloat(cleaned);
          };

          const matchedCategory = categoriesResponse.data.find(
            cat => cat.category_id == item.category_id
          );

          const categoryName = matchedCategory ? matchedCategory.category : 'Property';

         let images = [buildingImage]; // Default image
try {
  const imageResponse = await getPropertyImages(item.property_id);

  if (imageResponse.success && imageResponse.images && imageResponse.images.length > 0) {
    images = imageResponse.images.map(img => {
      if (img.startsWith('http')) {
        return img;
      } else if (img.startsWith('/')) {
        return `${BASE_URL}${img}`;
      } else {
        return `${BASE_URL}/${img}`;
      }
    });
  }
} catch (imgError) {
  console.error(`Error fetching images for property ${item.property_id}:`, imgError);
}

          return {
            id: item.property_id,
            title: categoryName,
            location: item.location || 'Not specified',
            price: item.price,
            formattedPrice: `₹${item.price?.toLocaleString()}`,
            date: item.created_at?.split('T')[0],
            facing: item.facing?.replace(/"/g, '') || 'N/A',
          site_area: item.site_area
  ? `${item.site_area} ${
      ["ft", "m", "cm", "in"].includes(item.units)
        ? `Sq ${item.units}`
        : item.units || "Sq ft"
    }`
  : 0,
            // max_acres: item.max_acres ? `${item.max_acres} ${item.units || "acres"}` : 'N/A',
            dimensions: item.roadwidth ? `${item.roadwidth} ft road` : 'N/A',
            posted_by: item.posted_by?.replace(/"/g, '') || 'Agent',
            lat: parseCoord(item.lat),
            long: parseCoord(item.long),
            length: item.length,
            width: item.width,
            mobile_no: item.mobile_no,
            property_name: item.property_name,
            images: images,
            propertyData: item,
            wishlistCount: wishlistCount,
            matchingBuyersCount: matchingBuyersCount,
              daysLeft: daysLeftForProperty,
              admin_status: item.Admin_status  || 'Pending',

            };
        }));

        setProperties(parsed);
        const initialIndexes = {};
        parsed.forEach(property => {
          initialIndexes[property.id] = 0;
        });
        setCurrentImageIndex(initialIndexes);
      } catch (error) {
        console.error('Error fetching data:', {
          message: error.message,
          response: error.response?.data,
          status: error.response?.status,
        });
      } finally {
        setLoading(false);
      }
    };
  useEffect(() => {

    fetchData();
  }, [userId]);

  const handleWishlistClick = (propertyId, e) => {
    e.stopPropagation();
    navigate(`/wishlist-users/${propertyId}`);
  };

  const handleMatchingBuyersClick = (propertyId, e) => {
    e.stopPropagation();
    navigate(`/matching-buyers/${propertyId}`);
  };

  const handleNextImage = (propertyId, e) => {
    e.stopPropagation();
    setCurrentImageIndex(prev => {
      const currentIndex = prev[propertyId];
      const property = properties.find(p => p.id == propertyId);
      const nextIndex = (currentIndex + 1) % property.images.length;
      return {
        ...prev,
        [propertyId]: nextIndex
      };
    });
  };

  const handlePrevImage = (propertyId, e) => {
    e.stopPropagation();
    setCurrentImageIndex(prev => {
      const currentIndex = prev[propertyId];
      const property = properties.find(p => p.id == propertyId);
      const prevIndex = (currentIndex - 1 + property.images.length) % property.images.length;
      return {
        ...prev,
        [propertyId]: prevIndex
      };
    });
  };

  const openGoogleMapsWithDirections = (destLat, destLng) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const currentLat = position.coords.latitude
          const currentLng = position.coords.longitude;

          const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${currentLat},${currentLng}&destination=${destLat},${destLng}&travelmode=driving`;

          window.open(googleMapsUrl, '_blank');
        },
        (error) => {
          console.error("Error getting location:", error);
          alert("Could not get your location. Please allow location access.");
        }
      );
    } else {
      alert("Geolocation is not supported by your browser.");
    }
  };

  const filteredProperties = properties.filter((property) =>
    property.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    property.location.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleDeleteProperty = async (propertyId) => {
    try {
      const response = await fetch(`${BASE_URL}/property/${propertyId}/`, {
        method: 'DELETE',
      });
  
      if (response.ok) {
        alert(`Property ID ${propertyId} deleted successfully.`);
        setProperties(prev => prev.filter(p => p.id !== propertyId));
      } else {
        const errorData = await response.json();
        alert(`Failed to delete property ID ${propertyId}. Reason: ${errorData.detail || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error deleting property:', error);
      alert('An error occurred while trying to delete the property.');
    }
  };

  const truncateText = (text, maxLength) => {
  if (!text) return '';
  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};

  const calculateDaysLeft = (expiredDate) => {
  if (!expiredDate) return 0;

  const now = new Date();
  const expiry = new Date(expiredDate);
  const diffTime = expiry - now;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays > 0 ? diffDays : 0;
};

const mapPostedByToUserType = (postedBy) => {
  if (!postedBy) return null;

  const value = postedBy.toLowerCase();

  if (value === "owner" || value === "builder") {
    return "Individual Owner/Builder";
  }

  if (value === "agent") {
    return "Agent";
  }

  return null;
};

  const handleBoostProperty = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/boost-property/`, { user_id: userId });
   console.log('Boost success:', response.data);
    setAlertMessage('Property boosted successfully!');
    setShowBoostSuccess(true);
    } catch (error) {
       console.error('Boost failed:', error);
    setAlertMessage('Failed to boost property. Please try again.');
    setShowBoostFailure(true);
    }finally {
    setBoostLoading(false);
  }
  };

  const handleExtensionClick = () => {
    navigate('/user-subscription');
  };

  // Loading spinner
  if (loading) {
    return (
      <Box
        sx={{
          backgroundColor: 'rgb(239, 231, 221)',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 3,
        }}
      >
        <CircularProgress size={40} thickness={5} sx={{ color: '#000000' }} />
        <Typography variant="h7" sx={{ color: '#000000', fontWeight: 600 }}>
          Loading best deals...
        </Typography>
      </Box>
    );
  }

  if (error) return <Box>Error: {error}</Box>;

  return (
    <Box sx={{ backgroundColor: 'rgb(239, 231, 221)', minHeight: '120vh' }}>
      {/* ✅ Fixed Header Section */}
      <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        backgroundColor: 'rgb(239, 231, 221)',
        px: 1,
        py: 1,
        boxShadow: '0 2px 6px rgba(0,0,0,0.05)'
      }}
    >
      {/* Search */}
      <CustomSearchBar
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />

      {/* Title + Boost */}
      <Box
        sx={{
          mt: 1,
          px: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Typography
          variant="h6"
          sx={{ fontWeight: 'bold' }}
        >
          My Best Deals
        </Typography>

       {filteredProperties.length > 0 && (
    <Button
      variant="contained"
      color="primary"
      onClick={handleBoostProperty}
      disabled={boostLoading}
      sx={{ fontSize: '0.8rem' }}
    >
      {boostLoading ? <CircularProgress size={20} sx={{ color: 'white' }} /> : 'Boost Your Property'}
    </Button>
  )}
      </Box>
    </Box>

    {/* ✅ Property List Section */}
    <Box
      sx={{
        pt: { xs: '140px', sm: '150px' },  // 🔥 important spacing
        pb: 8
      }}
    >
        {properties.length === 0 ? (
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '200px',
            px: 2
          }}>
            <Typography>No properties found.</Typography>
          </Box>
        ) : filteredProperties.length === 0 ? (
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '200px',
            px: 2
          }}>
            <Typography>No properties found matching your search.</Typography>
          </Box>
        ) : (
          filteredProperties.map((property) => (
            <Card
              key={property.id}
              sx={{
                mb: 1.2,
                mx: 2,
                borderRadius: 3,
                boxShadow: 2,
                transition: 'transform 0.2s ease-in-out',
                '&:hover': { transform: 'scale(1.015)', boxShadow: 4 },
              }}
              onClick={(e) => {
                const isInteractiveElement = 
                  e.target.closest('button') || 
                  e.target.closest('svg') || 
                  e.target.closest('.MuiMenu-root') ||
                  e.target.closest('.MuiMenuItem-root');
                
                if (!isInteractiveElement) {
                  navigate('/buy-description', { state: { propertyId: property.id, property: property.propertyData } });
                }
              }}
            >
              <Box position="relative">
                <CardMedia
                  component="img"
                  image={property.images[currentImageIndex[property.id]]}
                  alt="Property"
                  sx={{
                    width: '100%',
                    height: '140px',
                    objectFit: 'cover',
                    borderTopLeftRadius: 12,
                    borderTopRightRadius: 12,
                  }}
                />

                {property.images.length > 1 && (
                  <>
                    <IconButton
                      sx={{
                        position: 'absolute',
                        top: '50%',
                        left: 8,
                        opacity: 0,
                        transform: 'translateY(-50%)',
                        backgroundColor: 'rgba(255,255,255,0.3)',
                        backdropFilter: 'blur(2px)',
                        '&:hover': {
                          opacity: 1,
                          backgroundColor: 'rgba(255,255,255,0.5)'
                        }
                      }}
                      onClick={(e) => handlePrevImage(property.id, e)}
                    >
                      <ChevronLeft fontSize="small" />
                    </IconButton>
                    <IconButton
                      sx={{
                        position: 'absolute',
                        top: '50%',
                        right: 8,
                        opacity: 0,
                        transform: 'translateY(-50%)',
                        backgroundColor: 'rgba(255,255,255,0.3)',
                        backdropFilter: 'blur(2px)',
                        '&:hover': {
                          opacity: 1,
                          backgroundColor: 'rgba(255,255,255,0.5)'
                        }
                      }}
                      onClick={(e) => handleNextImage(property.id, e)}
                    >
                      <ChevronRight fontSize="small" />
                    </IconButton>
                  </>
                )}

                {property.images.length > 1 && (
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: 10,
                      left: '50%',
                      transform: 'translateX(-50%)',
                      display: 'flex',
                      gap: 1
                    }}
                  >
                    {property.images.map((_, index) => (
                      <Box
                        key={index}
                        onClick={(e) => {
                          e.stopPropagation();
                          setCurrentImageIndex(prev => ({
                            ...prev,
                            [property.id]: index
                          }));
                        }}
                        sx={{
                          width: 8,
                          height: 8,
                          borderRadius: '50%',
                          backgroundColor: currentImageIndex[property.id] == index ? '#1976d2' : '#ccc',
                          cursor: 'pointer',
                          transition: 'background-color 0.3s'
                        }}
                      />
                    ))}
                  </Box>
                )}

                <Box sx={{ position: 'absolute', top: 6, right: 6, display: 'flex', gap: 1 }}>
                  <Tooltip title="Share">
                    <IconButton
                      size="small"
                      sx={{ bgcolor: 'white' }}
                      onClick={(e) => handleShare(e, property)}
                    >
                      <Share fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="More Options">
                    <IconButton
                      size="small"
                      sx={{ bgcolor: 'white' }}
                      onClick={(e) => handleMenuOpen(e, property.id)}
                    >
                      <MoreVert fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <MenuItem 
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEdit();
                    }}
                  >
                    Edit
                  </MenuItem>
                 <MenuItem 
  onClick={(e) => {
    e.stopPropagation();
    setMenuPropertyIdToDelete(menuPropertyId);
    setShowDeleteConfirm(true);
    handleMenuClose(); // Close the menu
  }}
>
  Delete
</MenuItem>
                </Menu>
              </Box>

              <CardContent sx={{ 
                px: 2, 
                py: 0.2, 
                pb: '7px !important',
                borderBottom: 'none',
                '&:last-child': {
                  paddingBottom: '7px !important',
                  borderBottom: 'none'
                } 
              }}>
                <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={0.5}>
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    noWrap
                    sx={{
                      flex: 1,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      pr: 1
                    }}
                  >
                     {property.title}-{truncateText(property.property_name, 17)}
                  </Typography>
                  <Typography variant="body2" fontWeight="bold" color="primary" noWrap>
                    ₹{Number(String(property.price).replace(/[^0-9]/g, '')).toLocaleString('en-IN')}
                  </Typography>
                </Box>

                <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    noWrap
                    sx={{
                      flex: 1,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      pr: 1
                    }}
                  >
                    {property.location}
                  </Typography>
                  <Typography variant="caption" color="text.secondary" noWrap>
                    {new Date(property.date).toLocaleDateString('en-IN', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric'
                    })}
                  </Typography>
                </Box>

                <Box display="flex" alignItems="center" mt={0.2}>
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      if (property.lat && property.long) {
                        openGoogleMapsWithDirections(property.lat, property.long);
                      }
                    }}
                  >
                    <LocationOn fontSize="small" color="action" />
                  </IconButton>

                  <Typography variant="caption" color="text.primary" ml={0.5}>
                    Location
                  </Typography>

                  
                    {property.admin_status && property.admin_status !== '' && (
                    <Box 
                      sx={{ 
                        mx: 2,
                        flex: 1,
                        display: 'flex',
                        justifyContent: 'center'
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '4px',
                          border: `1px solid ${
                            property.admin_status?.toLowerCase() === 'approved'
                              ? '#5dc460f2'
                              : '#f85347f2'
                          }`,
                          color: '#000000be',
                          px: 1.5,
                          py: 0.4,
                          borderRadius: 0,
                          fontSize: '0.7rem',
                          fontWeight: 'bold',
                          letterSpacing: '0.5px',
                          backgroundColor: 'transparent'
                        }}
                      >
                        {/* ✅ Icon Logic */}
                        {property.admin_status?.toLowerCase() === 'approved' && (
                          <CheckCircleIcon sx={{ fontSize: 14, color: '#4caf50' }} />
                        )}
                  
                        {property.admin_status?.toLowerCase() === 'rejected' && (
                          <CancelIcon sx={{ fontSize: 14, color: '#f44336' }} />
                        )}
                  
                        {property.admin_status?.toLowerCase() === 'pending' && (
                          <HourglassEmptyIcon sx={{ fontSize: 14, color: '#f44336' }} />
                        )}
                  
                        {property.admin_status}
                      </Typography>
                    </Box>
                  )}
                  <Box sx={{ flexGrow: 1 }} />
                  <Button
                    size="small"
                    variant="outlined"
                    color="success"
                    startIcon={<Call />}
                    sx={{ textTransform: 'none', px: 1.2, py: 0.3, fontSize: '0.7rem' }}
                    // onClick={(e) => e.stopPropagation()}
                       onClick={(e) => handleCallClick(e, property)}
                  >
                    Call
                  </Button>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                    overflow: 'hidden',
                  }}
                >
                  {[
                    { label: 'Facing', value: property.facing },
                    { label: `Area `, value: property.site_area },
                    { label: 'Posted By', value: property.posted_by },
                  ].map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        flex: 1,
                        px: 1,
                        py: 0.2,
                        textAlign: 'center',
                        borderRight: index < 2 ? '1px solid #e0e0e0' : 'none',
                      }}
                    >
                      <Typography variant="caption" color="text.secondary" noWrap>
                        {item.label}
                      </Typography>
                      <Typography variant="body2" fontWeight="bold" noWrap>
                        {item.value}
                      </Typography>
                    </Box>
                  ))}
                </Box>
                
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '2px',
                  py: 1,
                  px: 1,
                  paddingLeft: 0,
                }}>
                  <Button
                    startIcon={<FavoriteBorder />}
                    variant="contained"
                    onClick={(e) => handleWishlistClick(property.id, e)}
                    sx={{
                      backgroundColor: '#F1C93B',
                      color: 'black',
                      fontSize: 'clamp(0.6rem, 2.5vw, 0.7rem)',
                      textTransform: 'none',
                      flex: '1 1 auto',
                      minWidth: '100px',
                      whiteSpace: 'nowrap',
                      '&:hover': { backgroundColor: '#e3b92f' },
                      py: 1,
                      px: 1,
                    }}
                  >
                    Wishlist ({property.wishlistCount})
                  </Button>
                  
                  <Button
                    variant="contained"
                    onClick={(e) => handleMatchingBuyersClick(property.id, e)}
                    sx={{
                      backgroundColor: '#2ECC71',
                      color: 'white',
                      fontSize: 'clamp(0.6rem, 2.5vw, 0.7rem)',
                      textTransform: 'none',
                      flex: '1 1 auto',
                      minWidth: '100px',
                      whiteSpace: 'nowrap',
                      '&:hover': { backgroundColor: '#28b765' },
                      py: 1,
                      px: 1,
                    }}
                  >
                    Matching ({property.matchingBuyersCount || 0})
                  </Button>
                  
                <Button
  variant="contained"
  onClick={(e) => {
    e.stopPropagation();
    setMenuPropertyIdToDelete(property.id);
    setShowDeleteConfirm(true);
  }}
  sx={{
    backgroundColor: '#E74C3C',
    color: 'white',
    fontSize: 'clamp(0.6rem, 2.5vw, 0.7rem)',
    textTransform: 'none',
    flex: '1 1 auto',
    minWidth: '100px', 
    whiteSpace: 'nowrap',
    '&:hover': { backgroundColor: '#c0392b' },
    py: 1,
    px: 1,
  }}
>
  Delete
</Button>
                </Box>

                <Box
                  sx={{
                    backgroundColor: '#f2f2f2',
                    borderRadius: '8px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                    maxWidth: { xs: 400, sm: 'none' },
                    width: '100%',
                    margin: { xs: '-3px -3px', sm: '0 auto' },
                    mt: 1,
                    px: { sm: 2 },
                  }}
                >
                  <Button
                      variant="contained"
                      disableElevation
                      disabled={property.daysLeft > 7}
                      onClick={handleExtensionClick}
                      sx={{
                        backgroundColor:
                          property.daysLeft > 0 ? '#d3d3d3' : '#ff6b6b',
                        color: 'black',
                        textTransform: 'none',
                        fontWeight: 'bold',
                        fontSize: '0.6rem',
                        p: 1.3,
                        '&:hover': {
                          backgroundColor:
                            property.daysLeft > 0 ? '#d3d3d3' : '#ff8787',
                        },
                        '&:disabled': {
                          backgroundColor: '#d3d3d3',
                          color: '#666666',
                        },
                      }}
                    >
                      Extend Your Post
                    </Button>
              <Typography
                sx={{
                  fontWeight: 'bold',
                  color:
                    property.daysLeft === null
                      ? 'primary.main'
                      : property.daysLeft === 0
                      ? 'red'
                      : property.daysLeft <= 7
                      ? 'orange'
                      : 'green',
                  fontSize: '0.85rem',
                  whiteSpace: 'nowrap',
                }}
              >
                {property.daysLeft === null ? (
                  'No Expiry'
                ) : property.daysLeft === 0 ? (
                  'Expired'
                ) : (
                  <>
                    Days left: <span style={{ fontWeight: 700 }}>{property.daysLeft}</span>
                  </>
                )}
              </Typography>
              
              </Box>
              </CardContent>
            </Card>
          ))
        )}
      </Box>

 {/* Copy Mobile Success */}
{showSuccess && (
  <CopySuccessAlert
    message={alertMessage}
    onClose={() => {
      setShowSuccess(false);
      setAlertMessage("");
    }}
  />
)}

{/* Copy Mobile Failure */}
{showFailure && (
  <CopyFailureAlert
    message={alertMessage}
    onClose={() => {
      setShowFailure(false);
      setAlertMessage("");
    }}
  />
)}

{/* Share Success */}
{showShareSuccess && (
  <ShareCopySuccessAlert
    message={alertMessage}
    onClose={() => {
      setShowShareSuccess(false);
      setAlertMessage("");
    }}
  />
)}

{/* Share Failure */}
{showShareFailure && (
  <ShareCopyFailureAlert
    message={alertMessage}
    onClose={() => {
      setShowShareFailure(false);
      setAlertMessage("");
    }}
  />
)}
{showDeleteConfirm && (
  <DeleteConfirmAlert
    message={`Are you sure you want to delete property ID ${menuPropertyIdToDelete}?`}
    onOk={() => {
      setShowDeleteConfirm(false);
      handleDelete(); // This will now use menuPropertyIdToDelete
    }}
    onCancel={() => {
      setShowDeleteConfirm(false);
      setMenuPropertyIdToDelete(null);
    }}
  />
)}

{/* Delete Success */}
{showDeleteSuccess && (
  <DeleteSuccessAlert
    message={alertMessage}
    onClose={() => {
      setShowDeleteSuccess(false);
      setAlertMessage("");
    }}
  />
)}

{/* Delete Failure */}
{showDeleteFailure && (
  <DeleteFailureAlert
    message={alertMessage}
    onClose={() => {
      setShowDeleteFailure(false);
      setAlertMessage("");
    }}
  />
)}
{/* Boost Success */}
{showBoostSuccess && (
  <BoostSuccessAlert
    message={alertMessage}
    onClose={() => {
      setShowBoostSuccess(false);
      setAlertMessage("");
    }}
  />
)}

{/* Boost Failure */}
{showBoostFailure && (
  <BoostFailureAlert
    message={alertMessage}
    onClose={() => {
      setShowBoostFailure(false);
      setAlertMessage("");
    }}
  />
)}
      <BottomNavbar />
    </Box>
  );
};

export default UserBestdeals;